import { Group } from 'three';
import { Object3DType } from 'shared/object3d/interfaces';
import { traverseObject3DMaterials } from 'shared/utils/three-utils';
export default class BaseObject3D extends Group {
    constructor() {
        super(...arguments);
        this.userData = {
            objectType: Object3DType.CANVAS_OBJECT,
        };
    }
    overrideOpacity(opacity) {
        traverseObject3DMaterials(this, (material) => {
            if (material.userData.tempOpacityApplied === true)
                return;
            material.userData.originalOpacity = material.opacity;
            material.opacity = opacity;
            material.userData.tempOpacityApplied = true;
        });
    }
    resetOpacity() {
        traverseObject3DMaterials(this, material => {
            if (material.userData.tempOpacityApplied === true) {
                material.opacity = material.userData.originalOpacity;
                material.userData.tempOpacityApplied = false;
            }
        });
    }
}
